export default __webpack_public_path__ + "static/media/P944_RoHS.b1a2662e.pdf";